import React, {} from 'react';

function Indentation(props) {

  function renderMain() {

    return <div className="indentation-main">
    	{props.children}
    </div>;

  }

  return renderMain();

}

export default Indentation;